import Button, { ButtonColorTypes } from "../shared-components/Button";
import {
  ConfirmationDialog,
  ConfirmationDialogIcon,
} from "../shared-components/ConfirmationDialog";

export interface OperationErrorDialogContent {
  title: string;
  message: string;
}

interface OperationErrorDialogProps {
  content: OperationErrorDialogContent | null;
  onClose: () => void;
}

function OperationErrorDialog({ content, onClose }: OperationErrorDialogProps) {
  if (!content) return null;

  return (
    <ConfirmationDialog
      isOpen
      title={content.title}
      text=""
      actionHandler={(action) => {
        if (action === "close") onClose();
      }}
      showActionButtons={false}
      icon={ConfirmationDialogIcon.WARN}
    >
      <div className="pl-[60px] pr-6 pb-2">
        <p className="text-gray-600 text-sm leading-relaxed mb-6">
          {content.message}
        </p>
        <div className="flex justify-end">
          <Button
            text="OK"
            colorType={ButtonColorTypes.primary}
            onClick={onClose}
            data-testid="operation-error-ok"
          />
        </div>
      </div>
    </ConfirmationDialog>
  );
}

export default OperationErrorDialog;
